
import { Component, Vue, Prop } from 'vue-property-decorator'
import FetchWrapper from '@/classes/fetchWrapper'

Vue.prototype.$multiwatch = function (props, watcher) {
  var iterator = function (prop) {
    this.$watch(prop, watcher)
  }
  props.forEach(iterator, this)
}

const LoginModalProps = Vue.extend({
  props: {
    canCancel: Boolean,
    close: Boolean
  }
})

@Component
export default class LoginModal extends LoginModalProps {
  // @Prop(Boolean) close: boolean | false
  data () {
    return {
      isLoading: false,
      email: '',
      password: '',
      formDataValid: false
    }
  }

  get isComponentModalActive () {
    return this.close
  }

  created () {
    this.$multiwatch(['email', 'password'], function () {
      this.validateForm()
    })
    this.$multiwatch(['close'], function () {
      this.timeoutValidateForm()
    })
  }

  timeoutValidateForm () {
    if (!this.$refs.form) {
      setTimeout(this.timeoutValidateForm, 50)
    } else {
      this.validateForm()
    }
  }

  validateForm () {
    this.formDataValid = this.$refs.form.checkValidity()
  }

  async login () {
    try {
      this.isLoading = true

      var data = {
        email: this.email,
        pwd: this.password
      }

      const resp = await FetchWrapper.post(`${process.env.VUE_APP_SERVERURL}/login`, data)

      this.isLoading = false
      if (resp.error) {
        this.$buefy.dialog.confirm({
          title: 'Error',
          message: resp.error,
          canCancel: false
        })
      } else {
        this.$store.commit('loggedIn', true)
        this.$store.commit('accessToken', resp.access_token)
        window.location.href = '/stats'
      }
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Could not Login. Reason: ${e}`,
        canCancel: false
      })
    }
  }
}
